<div style="height: 100%; padding-bottom: 0; margin: 0;">
    <div class="cdk-virtual-scroll-data-source-example" joyrideStep="firstStep" [title]="'Welcome!'"
        text="Here you'll find the KPIs of enabled Features. Click on the feature tile to navigate to the corresponding Feature.">
        <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="50" class="example-viewport">
            <div *cdkVirtualFor="let item of navMenuList">
                <mat-card *ngIf="item.FEATURE_NAME !== 'Metrics'" class="example-item"
                    style="padding: 0; cursor: pointer;" [style.background]="item.color">
                    <div fxLayout="column" style="height: 100%;" (click)="goToFeature(item)">
                        <div fxFlex="90" fxLayoutAlign="center center">
                            <div style="font-size: 64px; color: white;">
                                0
                            </div>
                        </div>
                        <div style="text-align: center; background: #0000006b; padding: .75em 0 .75em 0;">
                            <span class="folio-header-style" style="color: white;">
                                {{item.FEATURE_NAME}} </span>
                        </div>
                    </div>
                </mat-card>
            </div>
        </cdk-virtual-scroll-viewport>
    </div>
    <div *ngIf="showSection" style="margin: 0 1em 0 1em; border: 1px solid #09522a62; border-radius: 4px;"
        joyrideStep="secondStep" [title]="'Description of each feature'"
        text="Here you'll find the description of each of the selected features.">
        <div style="margin: 1em;" fxLayout="row" fxLayoutAlign="space-between center">
            <span class="section-description">Description of each Feature avaialble in this account.</span>
            <button mat-button class="hide-section-button" (click)="hideHelpSection()" joyrideStep="thirdStep"
                [title]="'Click here to hide.'"
                text="You can hide this section by clicking here. This can always be enabled in the settings at any time.">Do
                not Show me
                again</button>
        </div>
        <hr style="border-top: 1px solid #09522a62;" />
        <div>
            <div *ngFor="let featureItem of featureItems" class="list-item">
                <div fxLayout="row" style="margin: .5em 0 .5em 0;">
                    <div #nameDescriptionSection fxFlex="80" fxlayout="column">
                        <div><span class="folio-header-style">{{featureItem.name}}</span></div>
                        <div class="feature-description-in-section"><span>{{featureItem.description}}</span></div>
                    </div>
                    <div #buttonSection fxFlex="20" class="create-feature-button-container">
                        <button mat-raised-button class="create-feature-button" color="accent"
                            (click)="goToFeature(featureItem)">
                            {{featureItem.canCreate ? 'Create ' : 'View ' }}{{featureItem.name.substr(featureItem.name.length-1) === 's' ? (featureItem.name | slice:0:featureItem.name.length-1) : featureItem.name}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>